<div class="right-sidenav">
  <ul class="list-unstyled">
    <ng-container *ngIf="username">
      <li>
        <a href="/account/profile" (click)="closeRightSidenav.emit()">
          <i class="menu-icon fa fa-user position-relative"></i>
          <span> {{username}} </span>
        </a>
      </li>
      <li [class.active-route]="router.url.includes('account')">
        <a routerLink="/account" (click)="closeRightSidenav.emit()">
          <i class="menu-icon fa fa-list position-relative"></i>
          <span> {{ "AUTH.MENU.ACCOUNT" | translate }}</span>
        </a>
      </li>
      <li [class.active-route]="router.url.includes('/account/bets')">
        <a routerLink="/account/bets" (click)="closeRightSidenav.emit()">
          <i class="menu-icon fas fa-history  position-relative"></i>
          <span> {{ "AUTH.MENU.BETS" | translate }} </span>
        </a>
      </li>
      <li [class.active-route]="router.url.includes('/account/profile')">
        <a routerLink="/account/profile" (click)="closeRightSidenav.emit()">
          <i class="menu-icon fa fa-user position-relative"></i>
          <span> {{ "AUTH.MENU.PROFILE" | translate }} </span>
        </a>
      </li>
      <li class="p-0">
        <app-language-toolbar [isSidebar]="true"></app-language-toolbar>
      </li>
      <li>
        <a href=" /" (click)="closeRightSidenav.emit();logOut();">
          <i class="menu-icon fa fa-sign-out-alt position-relative"></i>
          <span> {{ 'HOME.LOGOUT' | translate }} </span>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
